// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__wwfrN","filter":"Menu_filter__If9If","filter_checkbox":"Menu_filter_checkbox__r9Aqc"};